import { useRef } from 'react'

function useRefState<S>(initialState: S): [() => S, (state: S) => void]

function useRefState<S = undefined>(
    initialState?: S
): [() => S | undefined, (state: S) => void] {
    const ref = useRef<S | undefined>(initialState)
    const setState = (state: S | undefined) => {
        ref.current = state
    }
    const getState = () => {
        return ref.current
    }

    return [getState, setState]
}

export default useRefState
